@if (!routerLink() && !href()) {
  <ng-container *ngTemplateOutlet="listItemContent"></ng-container>
} @else {
  @if (routerLink()) {
    <a class="list-item-link" [routerLink]="routerLink()" [routerLinkActive]="routerLinkActive()">
      <ng-container *ngTemplateOutlet="listItemContent"></ng-container>
    </a>
  } @else if (href()) {
    @if (href().includes('http')) {
      <a class="list-item-link" [href]="href()" target="_blank" rel="noopener noreferrer">
        <ng-container *ngTemplateOutlet="listItemContent"></ng-container>
      </a>
    } @else {
      <a class="list-item-link" [href]="href()">
        <ng-container *ngTemplateOutlet="listItemContent"></ng-container>
      </a>
    }
  }
}

<ng-template #listItemContent>
  <div class="interactive-overlay">
    @if (useCheckbox()) {
      <div class="check-box"></div>
    } @else {
      <div class="isSelected">
        <mdw-icon
          [icon]="icons.Check_Small"
          [class]="
            isDisabled ? 'disabled' : 'color-preset-' + iconPresetColorNumber() || iconColorClass
          "
        ></mdw-icon>
      </div>
    }
    @if (icon()) {
      <mdw-icon
        [icon]="icon()"
        class="secondary"
        [class.small-icon]="iconSize() === 'small'"
        [class]="
          isDisabled ? 'disabled' : 'color-preset-' + iconPresetColorNumber() || iconColorClass
        "
      ></mdw-icon>
    }
    <div class="hflex-000 fill-flex overflow-x-hidden flex-align-items-center">
      <span class="text-content">
        <ng-content></ng-content>
      </span>

      <mdw-swap-animate
        [model]="badge()"
        class="notification-container"
        [class.has-badge]="!!badge()"
      >
        <ng-template mdwSwap let-badge>
          @if (badge) {
            @if (badgeStyle() === 'Count') {
              <span class="badge-count small primary">{{ badge }}</span>
            } @else {
              <div class="mdw-notification-badge">{{ badge }}</div>
            }
          }
        </ng-template>
      </mdw-swap-animate>
    </div>

    @if (includeToggle()) {
      <input type="checkbox" toggle [checked]="toggleChecked()" />
    }

    @if (includeHideOnHover()) {
      <button
        class="mdw-button mdw-tertiary small-button hide-button"
        [icon]="icons.Close_Medium"
        (pointerdown)="preventBubble($event)"
        (click)="hide.emit($event)"
      ></button>
    }
  </div>
</ng-template>
